import React, { useEffect } from 'react';
import { ContractsReceiptWrapper, HelixLoader } from 'components';
import {
    DisplayItem,
    getContractOwnerIdOrEffectiveIdName,
    getLoggedInIdName,
} from 'components/contracts-receipt-wrapper/contracts-receipt-wrapper-helper';
import { SMART_CONTRACT_PATHS } from 'constants/smart-contracts-paths';
import { useWalletList } from 'hooks';
import { toLocalDateTimeString } from 'lib';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

export const SmartContractReceipts = (): React.JSX.Element => {
    const { sdoId, chain } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const { data: walletsData, isLoading: walletsLoading } = useWalletList();
    const smartContractReceiptData = location.state;

    useEffect(() => {
        if (!location.state) {
            navigate(`${SMART_CONTRACT_PATHS.LANDING_PAGE}?tab=Receipts`, {
                state: chain,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);

    const onBackArrowClick = (): void => {
        navigate(`${SMART_CONTRACT_PATHS.LANDING_PAGE}?tab=Receipts`, {
            state: chain,
        });
    };

    const informationDisplayItems: DisplayItem[] = [
        {
            label: 'SDOID',
            value: sdoId ?? '--',
        },
        {
            label: 'Contract Owner',
            value: getContractOwnerIdOrEffectiveIdName(
                walletsData,
                smartContractReceiptData?.contractOwnerId
            ),
        },
        {
            label: 'EffectiveID',
            value: getContractOwnerIdOrEffectiveIdName(
                walletsData,
                smartContractReceiptData?.effectiveId
            ),
        },
        {
            label: 'LoggedInID',
            value: getLoggedInIdName(
                walletsData,
                smartContractReceiptData?.loggedInId
            ),
        },
        {
            label: 'Function',
            value: smartContractReceiptData?.receiptSmartContract?.function,
        },
        {
            label: 'Arguments',
            value: JSON.stringify(
                smartContractReceiptData?.receiptSmartContract?.arguments
            ),
            isCode: true,
        },
        {
            label: 'Successful',
            value: smartContractReceiptData?.receiptSmartContract?.successful?.toString(),
        },
        {
            label: 'Console',
            value: smartContractReceiptData?.receiptSmartContract?.consoleBase64
                ? atob(
                      smartContractReceiptData?.receiptSmartContract
                          ?.consoleBase64
                  )
                : '',
            isCode: true,
        },
        {
            label: 'Error Log',
            value: smartContractReceiptData?.receiptSmartContract
                ?.errorLogBase64
                ? atob(
                      smartContractReceiptData?.receiptSmartContract
                          ?.errorLogBase64
                  )
                : '',
            isCode: true,
        },
    ];

    const headerDisplayItems: DisplayItem[] = [
        {
            label: 'Timestamp',
            value:
                toLocalDateTimeString(
                    smartContractReceiptData?.header?.timestamp
                ) ?? '--',
        },
        {
            label: 'ID',
            value: smartContractReceiptData?.header?.id ?? '--',
        },
        {
            label: 'Type',
            value: smartContractReceiptData?.header?.type ?? '--',
        },
        {
            label: 'Operation',
            value: smartContractReceiptData?.header?.operation ?? '--',
        },
        {
            label: 'Owners',
            value: smartContractReceiptData?.header?.owners[0] ?? '--',
        },
        {
            label: 'Limited Owners',
            value: smartContractReceiptData?.header?.limitedOwners[0] ?? '--',
        },
        {
            label: 'Signer',
            value: smartContractReceiptData?.header?.signer ?? '--',
        },
        {
            label: 'Signature',
            value: smartContractReceiptData?.header?.signature ?? '--',
        },
        {
            label: 'Dictionary',
            value: smartContractReceiptData?.header?.dictionary ?? '--',
        },
        {
            label: 'Hash',
            value: smartContractReceiptData?.header?.hash ?? '--',
        },
    ];

    if (walletsLoading) {
        return <HelixLoader />;
    }

    return (
        <ContractsReceiptWrapper
            chain={chain ?? ''}
            breadCrumType='Smart_Contract'
            onBackArrowClick={onBackArrowClick}
            informationDisplayItems={informationDisplayItems}
            headerDisplayItems={headerDisplayItems}
        />
    );
};
